import { createStore } from "zustand/vanilla";
import { preloadRepo } from "./preload";

export type TContentTable = {
  entity: string;
  src: string;
  title: string;
  table: string[][];
  width: string;
};

export type TInfoKey =
  | "game-rules"
  | "paytable"
  | "wild"
  | "payout"
  | "ui-guide"
  | "win-case";

export interface IInfoElement {
  type:
    | "title"
    | "list"
    | "line"
    | "header"
    | "figure"
    | "gallery"
    | "grid"
    | "image"
    | "text";
  content: any;
  items_width?: number;
  dep_event?: string;
}

export type TInfoRepo = {
  data: {
    [key in TInfoKey]?: IInfoElement[];
  };
  changeUIActive: (isUIActive: boolean) => void;
};

export const infoRepo = createStore<TInfoRepo>((set, get) => ({
  data: {},
  changeUIActive: (isUIActive) => {},
}));

export const preloadInfoData = async () => {
  try {
    const { setProgress, finish } = preloadRepo.getState();

    const data: Record<string, any> = {
      "game-rules": [],
      paytable: [],
      wild: [],
      payout: [],
      "win-case": [],
    };

    setProgress("info", 50);

    setProgress("info", 100);

    infoRepo.setState({
      data,
    });

    finish("info");
  } catch (e) {}
};

export const updatePayout = (data: Record<string, any[]>) => {
  return data;
};
